import React from "react";
import { Box } from "@mui/material";
import { Outlet, useMatch } from "react-router-dom";
import InboundEmailDashboard from "../components/inbound-email/InboundEmailDashboard";

/**
 * Dedicated Inbound Email screen (Automation).
 * Dashboard at /inbound-email; email details nested at /inbound-email/events/:eventId.
 */
export default function InboundEmailView() {
  const isDetail = useMatch("/inbound-email/events/:eventId");
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: "auto", width: "100%", minWidth: 0 }}>
      {isDetail ? <Outlet /> : <InboundEmailDashboard />}
    </Box>
  );
}
